import { Cell, TitleCell, TitleRow } from 'components/ReusableComponents/Table'

const InHouseTitleRow = () => (
  <TitleRow style={{ position: 'sticky', top: 70 }}>
    <TitleCell>last week</TitleCell>
    <TitleCell>this week</TitleCell>
    <TitleCell>yesterday</TitleCell>
    <Cell></Cell>
    <TitleCell>last week</TitleCell>
    <TitleCell>this week</TitleCell>
    <TitleCell>yesterday</TitleCell>
  </TitleRow>
)

export default InHouseTitleRow
